import React from "react";
import { Box } from "@mui/material";

import TermsHeader from "../../components/Terms/TermsHeader";
import TermsContent from "../../components/Terms/TermsContent";

const Terms = () => {
  return (
    <Box
      sx={{
        height: "calc(100vh - 64px )",
        overflowY: "auto",
        paddingX: "16px",
        backgroundColor: "#FFFFFF",
      }}
      className='conditions'
    >
      <TermsHeader />
      <TermsContent />
    </Box>
  );
};

export default Terms;
